import React from 'react';
import PropTypes from 'prop-types';
import { useNotify, useListContext, Button } from 'react-admin';
import GetAppIcon from '@mui/icons-material/GetApp';

import { apiPost } from '@src/services/api/helpers';

const DownloadZipButton = ({ resource }) => {
    if (resource === 'rate_bulletins' || resource === 'underwriting_guidelines' || resource === 'program_guides') {
        resource = 'guides';
    }

    const { selectedIds } = useListContext();
    const notify = useNotify();
    const [loading, setLoading] = React.useState(false);

    const handleDownload = async () => {
        if (!selectedIds || selectedIds.length === 0) {
            notify('Please select at least one item to download', 'warning');
            return;
        }

        setLoading(true);
        try {
            const response = await apiPost(`/${resource}/download_zip`, {
                ids: selectedIds,
            });

            // Server returns JSON with download_url
            const { download_url: downloadUrl } = response.data;

            if (downloadUrl) {
                // Redirect to the download URL
                window.location.href = downloadUrl;
                notify('ZIP file download started', 'success');
            } else {
                throw new Error('No download URL received from server');
            }
        } catch (_) {
            notify('Failed to download ZIP file', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            label={loading ? 'Downloading...' : 'Download ZIP File'}
            disabled={loading || !selectedIds || selectedIds.length === 0}
            onClick={handleDownload}
        >
            <GetAppIcon />
        </Button>
    );
};

DownloadZipButton.propTypes = {
    resource: PropTypes.string.isRequired,
};

export default React.memo(DownloadZipButton);
